import React from 'react';
import GuestPlayerModal from "./GuestPlayerModal"
import {Button, Divider, List} from "semantic-ui-react";
import BeerIcons from "./BeerIcons";

const ParticipantList = ({training, participantState, postEvent, showAddGuestButton}) => {
    const participantRows = training.participants
        .filter(p => p.state === participantState)
        .sort((p1, p2) => p1.answerDate >= p2.answerDate ? 1 : -1)
        .map((participant, index) =>
            <ParticipantRow training={training} participant={participant}
                            key={participant.id} onWaitingList={participant.state === "ATTENDING" && index >= 12}
                            postEvent={postEvent}/>)

    const dividerText = participantState === "ATTENDING"
        ? "Påmeldte"
        : (participantState === "NOT_ATTENDING"
            ? "Avmeldte"
            : "Ubesvarte");

    const addGuestButton = showAddGuestButton && !training.cancelled;

    return participantRows.length || addGuestButton ? <React.Fragment>
        <Divider horizontal>{dividerText}</Divider>
        <List selection={true}>
            {participantRows}
            {showAddGuestButton && !training.cancelled &&
                <AddGuestParticipantRow key={'guest-row'} postEvent={postEvent} trainingId={training.id}/>}
        </List>
    </React.Fragment> : null
}

const ParticipantRow = ({training, participant, postEvent, onWaitingList}) => {
    const iconColor = participant.state === "ATTENDING"
        ? (onWaitingList ? 'olive' : 'green')
        : (participant.state === "NOT_ATTENDING"
            ? "red"
            : "grey");
    return <List.Item>
        {!training.cancelled && <List.Content floated="right">
            <Button
                basic
                size="tiny"
                color={'green'}
                disabled={participant.state === "ATTENDING"}
                onClick={() => postEvent({
                    type: "SET_PARTICIPANT_IS_ATTENDING",
                    cageTrainingId: training.id,
                    playerId: participant.id
                })}
            >
                {training.finished ? 'Kom likevel' : 'Meld på'}
            </Button>
        </List.Content>}
        {!training.cancelled && <List.Content floated='right'>
            <Button
                basic
                size="tiny"
                color={'red'}
                disabled={participant.state === "NOT_ATTENDING"}
                onClick={() => postEvent({
                    type: 'SET_PARTICIPANT_IS_NOT_ATTENDING',
                    cageTrainingId: training.id,
                    playerId: participant.id
                })}
            >
                {training.finished ? 'Kom ikke' : 'Meld av'}
            </Button>
        </List.Content>}
        <List.Icon className="participant__row--icon" name='user' color={iconColor} size="large"/>
        <List.Content className="participant__row--content">
            <List.Header className="participant__row--header">
                {participant.name + (onWaitingList ? ' (Venteliste)' : '')}{' '}{' '}{' '}{participant.regular ?
                <BeerIcons beerPunishment={participant.beerPunishment}/> : "(Gjest)"}
            </List.Header>
        </List.Content>
    </List.Item>
}

const AddGuestParticipantRow = ({postEvent, trainingId}) =>
    <List.Item>
        <List.Content floated="right">
            <GuestPlayerModal postEvent={postEvent} trainingId={trainingId}/>
        </List.Content>
        <List.Icon className="participant__row--icon" name="user plus" size="large"/>
        <List.Content className="participant__row--content">
            <List.Header className="participant__row--header">
                Ny gjestespiller
            </List.Header>
        </List.Content>
    </List.Item>;

const CageTraining = ({training, postEvent}) =>
    <React.Fragment>
        <ParticipantList training={training} postEvent={postEvent}
                         participantState="ATTENDING"
                         showAddGuestButton={false}/>
        <ParticipantList training={training} postEvent={postEvent}
                         participantState="NOT_ATTENDING"
                         showAddGuestButton={false}/>
        <ParticipantList training={training} postEvent={postEvent}
                         participantState="UNANSWERED"
                         showAddGuestButton={true}/>
    </React.Fragment>;

export default CageTraining;



// WEBPACK FOOTER //
// ./src/Components/CageTraining.js